import React, { useState } from "react";
import { connect  } from "react-redux";
import { Tabs } from "antd";
import { Briefcase, ClipboardList, User } from "lucide-react";
import MyProfileForm from "./MyProfileForm";
import MyApplicationsPanel from "./MyApplicationsPanel";
import MyAssessmentsPanel from "./MyAssessmentsPanel";

const ProfileTabs = ({ defaultActiveTab, editMode=false, myApplicationList }) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab ?? "my-profile");
  const [editingProfile, setEditingProfile] = useState(editMode);

  const TabLabel = ({ text, icon: Icon, count }) => (
    <div className="flex items-center gap-2 text-lg">
      <Icon className="w-5 h-5" />
      <span>{text}</span>
      {typeof count === "number" && (
        <span className="ml-1 px-2 py-0.5 bg-gray-100 text-gray-700 rounded-full text-xs">
          {count}
        </span>
      )}
    </div>
  );

  const tabOptions = [
    { key: "my-profile", label: <TabLabel icon={User} text="My Profile" /> },
    { key: "applications", label: <TabLabel icon={Briefcase} text="My Applications" count={myApplicationList?.length} /> },
    { key: "assessments", label: <TabLabel icon={ClipboardList} text="My Assessments" count={0} /> },
  ];

  return (
    <div className="flex flex-col gap-4">
      <Tabs
        activeKey={activeTab}
        onChange={(key) => {
          setActiveTab(key);
          if (key !== "my-profile") setEditingProfile(false); // exit editing if switching tabs
        }}
        items={tabOptions}
        className="custom-tabs"
        tabBarGutter={32}
        animated={false}
      />

      <div className="mt-3">
        {activeTab === "my-profile" && (
          <MyProfileForm mode={editingProfile ? 'edit' : 'view'}/>
        )}
        {activeTab === "applications" && <MyApplicationsPanel />}
        {activeTab === "assessments" && <MyAssessmentsPanel />}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  myApplicationList: state.jobApplicant.jobApplicantList?.items,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileTabs);
